export const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:3000';
export const yearOfFoundation = 2016;
export const companyWebsite = 'TPN-LABS.COM';
export const platformName = 'Popasuri Românești';
export const captchaSiteKey = '6LcHK78UAAAAAIFskRtdqaGctziZDhsfRpnjVHcg';

export const defaultPageSize = 15;
